/**
 * Hostname constants for environment detection
 */
const HOSTNAMES = Object.freeze({
    // Production Environments
    US_PROD: 'us.fv-outlook-addin.prod.filevine.com',
    CA_PROD: 'ca.fv-outlook-addin.prod.filevine.ca',
    CJIS_PROD: 'us.fv-outlook-addin.highsec.filevinegov.com',

    // Non-Production Environments
    US_DEV: 'us.fv-outlook-addin.dev.filevinedev.com',
    US_STABLE: 'us.fv-outlook-addin.stable.filevinedev.com',
    EPHEMERAL_PATTERN: 'fv-outlook-addin.eph.filevinedev.com',

    // Local Environment
    LOCAL: 'localhost',
} as const);


/**
 * Navigate to the environment selector app
 */
const navigateToEnvironmentSelector = () => {
    const hostname = window.location.hostname;
    const isLocal = hostname === HOSTNAMES.LOCAL;
    const isProd = hostname === HOSTNAMES.US_PROD || hostname === HOSTNAMES.CA_PROD || hostname === HOSTNAMES.CJIS_PROD;

    if (isLocal) {
        // Local: different origin (port 5173 instead of 3003)
        window.location.href = 'https://localhost:5173/env-selector/index.html?forceSelection=true';
    } else if (isProd) {
        // Production: always use CJIS origin
        window.location.href = `https://${HOSTNAMES.CJIS_PROD}/env-selector/index.html?forceSelection=true`;
    } else {
        // All other environments: same origin, different path
        window.location.href = `${window.location.origin}/env-selector/index.html?forceSelection=true`;
    }
};

export { navigateToEnvironmentSelector };
export default HOSTNAMES;
